import React from 'react'
import { Switch } from 'react-router-dom'

import PrivateRoute from '../../components/PrivateRoute'
import ScrollToTop from '../../components/ScrollToTop'

// Landing
import DailyView from '../../pages/Professionals/DailyView'
import MonthlyView from '../../pages/Professionals/MonthlyView'

// Dashboard
import Dashboard from '../../pages/Professionals/Dashboard'

// Services
import ServicesDetails from '../../pages/Professionals/Dashboard/ServicesDetails'
import ClientsDetails from '../../pages/Professionals/Dashboard/ClientsDetails'

// Scheduling
import SchedulingsDetails from '../../pages/Professionals/Dashboard/SchedulingsDetails'
import StatusDetails from '../../pages/Professionals/Dashboard/SchedulingsDetails/StatusDetails'

// Billing
import BillingDetails from '../../pages/Professionals/Dashboard/BillingDetails'

// Solicitations
import SolicitationsView from '../../pages/Professionals/SolicitationsView'
import AgendaBlockSolicitationView from '../../pages/Professionals/AgendaBlockSolicitationView'
import SchedulingSolicitationView from '../../pages/Professionals/SchedulingSolicitationView'
import SolicitationsHistory from '../../pages/Professionals/SolicitationsHistory'

// Notifications
import Notifications from '../../pages/Professionals/Notifications'
import NotificationDetail from '../../pages/Professionals/Notifications/NotificationDetail'
import DailyBilling from '../../pages/Professionals/Dashboard/DailyBilling'
import DailyAttendance from '../../pages/Professionals/Dashboard/DailyAttendance'
import PrivacyPolicy from '../../pages/Professionals/PrivacyPolicy'

const Professionals = ({ isFreelance }) => {
  return <>
    <Switch>
      <PrivateRoute path='/daily'>
        <ScrollToTop />
        <DailyView />
      </PrivateRoute>
      <PrivateRoute path='/monthly'>
        <ScrollToTop />
        <MonthlyView />
      </PrivateRoute>
      {!isFreelance && (
        <PrivateRoute path='/privacy-policy'>
          <ScrollToTop />
          <PrivacyPolicy />
        </PrivateRoute>
      )}
      {!isFreelance && (
        <PrivateRoute path='/dashboard/scheduling-details/daily'>
          <ScrollToTop />
          <DailyAttendance />
        </PrivateRoute>
      )}
      {!isFreelance && (
        <PrivateRoute path='/dashboard/scheduling-details/status'>
          <ScrollToTop />
          <StatusDetails />
        </PrivateRoute>
      )}
      {!isFreelance && (
        <PrivateRoute path='/dashboard/scheduling-details'>
          <ScrollToTop />
          <SchedulingsDetails />
        </PrivateRoute>
      )}
      {!isFreelance && (
        <PrivateRoute path='/dashboard/billing/daily'>
          <ScrollToTop />
          <DailyBilling />
        </PrivateRoute>
      )}
      {!isFreelance && (
        <PrivateRoute path='/dashboard/billing'>
          <ScrollToTop />
          <BillingDetails />
        </PrivateRoute>
      )}
      {!isFreelance && (
        <PrivateRoute path='/dashboard/services/clients'>
          <ScrollToTop />
          <ClientsDetails />
        </PrivateRoute>
      )}
      {!isFreelance && (
        <PrivateRoute path='/dashboard/services'>
          <ScrollToTop />
          <ServicesDetails />
        </PrivateRoute>
      )}
      {!isFreelance && (
        <PrivateRoute path='/dashboard'>
          <ScrollToTop />
          <Dashboard />
        </PrivateRoute>
      )}
      <PrivateRoute path='/solicitations'>
        <ScrollToTop />
        <SolicitationsView />
      </PrivateRoute>
      <PrivateRoute path='/notifications'>
        <ScrollToTop />
        <Notifications />
      </PrivateRoute>
      <PrivateRoute path='/notification-details/:id'>
        <ScrollToTop />
        <NotificationDetail />
      </PrivateRoute>
      <PrivateRoute path='/new-agenda-block'>
        <ScrollToTop />
        <AgendaBlockSolicitationView />
      </PrivateRoute>
      <PrivateRoute path='/new-scheduling'>
        <ScrollToTop />
        <SchedulingSolicitationView />
      </PrivateRoute>
      <PrivateRoute path='/solicitations-history'>
        <ScrollToTop />
        <SolicitationsHistory />
      </PrivateRoute>
      <PrivateRoute path='/'>
        <ScrollToTop />
        <MonthlyView />
      </PrivateRoute>
    </Switch>
  </>
}

export default Professionals
